// extracted by mini-css-extract-plugin
export default {"summary_card":"summaryCard_summary_card__6i9gu","header":"summaryCard_header__XEwEI"};